import { render, staticRenderFns } from "./AdminUserCommissionItem.vue?vue&type=template&id=5aa84800&scoped=true"
import script from "./AdminUserCommissionItem.vue?vue&type=script&lang=js"
export * from "./AdminUserCommissionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa84800",
  null
  
)

export default component.exports